{
  "previous": "Previous",
  "next": "Next"
}
